import {
  useInfiniteQuery,
  type QueryKey,
  type QueryFunctionContext,
} from '@tanstack/react-query';

import { api } from 'utils/api';
import { applicationKeys } from './queryKeys';
import type { NewArtistApplicationResponse } from '../types';

const getNewArtistApplication = (lastApplicationId?: string) => {
  if (lastApplicationId) {
    return api.get<NewArtistApplicationResponse>(
      `/artists/applications/new?skipApplicationId=${lastApplicationId}`,
    );
  }
  return api.get<NewArtistApplicationResponse>('/artists/applications/new');
};

const useNewArtistApplication = () =>
  useInfiniteQuery<
    NewArtistApplicationResponse,
    Error,
    NewArtistApplicationResponse,
    QueryKey,
    string | undefined
  >({
    queryKey: applicationKeys.new(),
    initialPageParam: undefined,
    queryFn: ({
                pageParam = undefined,
              }: QueryFunctionContext<QueryKey, string | undefined>) =>
      getNewArtistApplication(pageParam),
    getNextPageParam: (lastPage: NewArtistApplicationResponse) =>
      lastPage.data?.[0]?.id ?? undefined,
    select: data => data.pages[0],
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
  });

export { useNewArtistApplication };